import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

/**
 * Emulates a mouse position in the center of the container
 * @param width -
 * @param height -
 * @param top -
 * @param left -
 */
export const calculateCenterPositions = (
  width: number,
  height: number,
  top: number,
  left: number,
): RelativeAbsolutePosition => {
  const relativePosition = {
    x: width / 2,
    y: height / 2,
  };

  const absolutePosition = {
    x: relativePosition.x + left,
    y: relativePosition.y + top,
  };

  return {
    relative: relativePosition,
    absolute: absolutePosition,
  };
};
